import React, { useState } from "react";
import { DateRange } from "react-date-range";
import { format, addDays } from "date-fns";
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { Dropdown } from "react-bootstrap";
import NotificationSystem from "./NotificationSystem";
import "../styles/Header.css";

const Header = ({ setDateRange, onLogout, onDashboardToggle, tasks, drivers, onTaskClick, onDriverClick }) => {
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 1),
      key: "selection",
    },
  ]);
  const [showPicker, setShowPicker] = useState(false);
  const [isSelectingStart, setIsSelectingStart] = useState(true);
  const [showMenu, setShowMenu] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    if (isSelectingStart) {
      setState([{ startDate, endDate: startDate, key: "selection" }]);
      setIsSelectingStart(false);
    } else {
      const validEndDate = endDate < startDate ? startDate : endDate;
      setState([{ startDate, endDate: validEndDate, key: "selection" }]);
      setDateRange({ startDate, endDate: validEndDate });
      setShowPicker(false);
      setIsSelectingStart(true);
    }
  };

  const toggleMenu = () => {
    setShowMenu((prev) => {
      console.log("Toggling showMenu:", !prev);
      return !prev;
    });
  };

  const closeMenu = () => {
    setShowMenu(false);
    console.log("Closing menu");
  };

  const focusVille = (lat, lng) => {
    document.querySelector(".map-container")?.dispatchEvent(
      new CustomEvent("focusOnCity", {
        detail: { lat, lng },
      })
    );
    closeMenu();
  };

  const handleLogoutClick = () => {
    onLogout();
    closeMenu();
  };

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      // Enter fullscreen
      document.documentElement
        .requestFullscreen()
        .then(() => {
          setIsFullscreen(true);
          console.log("Entered fullscreen mode");
        })
        .catch((err) => {
          console.error("Error entering fullscreen:", err);
        });
    } else {
      // Exit fullscreen
      document
        .exitFullscreen()
        .then(() => {
          setIsFullscreen(false);
          console.log("Exited fullscreen mode");
        })
        .catch((err) => {
          console.error("Error exiting fullscreen:", err);
        });
    }
  };

  // Listen for fullscreen changes to keep state in sync
  React.useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
      console.log("Fullscreen state changed:", document.fullscreenElement ? "On" : "Off");
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const formattedDateRange = `${format(state[0].startDate, "MM/dd/yyyy")} - ${format(state[0].endDate, "MM/dd/yyyy")}`;

  return (
    <header className="header">
      <a href="#" className="logo">
        <img
          src="https://lalivraison.ma/assets/images/logo-header.png"
          alt="Lalivraison"
          width="163"
          height="50"
        />
      </a>
      <div className="date-range-picker">
        <input
          type="text"
          value={formattedDateRange}
          onClick={() => setShowPicker(!showPicker)}
          readOnly
        />
        {showPicker && (
          <div className="picker-overlay" onClick={() => setShowPicker(false)}>
            <div className="picker-content" onClick={(e) => e.stopPropagation()}>
              <DateRange
                editableDateInputs={true}
                onChange={handleSelect}
                moveRangeOnFirstSelection={false}
                ranges={state}
                className="date-range"
                locale={enUS}
                rangeColors={["#26A69A"]}
              />
            </div>
          </div>
        )}
      </div>
      <button
        className="hamburger-menu"
        onClick={toggleMenu}
        aria-label={showMenu ? "Close menu" : "Open menu"}
        aria-expanded={showMenu}
      >
        <i className={`fas ${showMenu ? "fa-times" : "fa-bars"}`}></i>
      </button>
      <nav className="navbar desktop-nav">
        <Dropdown>
          <Dropdown.Toggle variant="warning" id="dropdown-basic">
            Choisir ville
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => focusVille(33.5745214, -7.6119033)}>
              CASABLANCA
            </Dropdown.Item>
            <Dropdown.Item onClick={() => focusVille(33.5215301, -7.8280355)}>
              DAR BOUZZA
            </Dropdown.Item>
            <Dropdown.Item onClick={() => focusVille(31.6294723, -7.9810845)}>
              MARRAKECH
            </Dropdown.Item>
            <Dropdown.Item onClick={() => focusVille(34.020882, -6.84165)}>
              RABAT
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
            <button 
              className="dashboard-toggle-btn" 
              onClick={onDashboardToggle}
              title="Dispatch Overview"
            >
              <i className="fas fa-chart-bar"></i>
              <span>Overview</span>
            </button>
            <a
              href="https://channelmanager.ma/Support"
              target="_blank"
              className="nav-link"
            >
              Delivrini - Support
            </a>
            <button className="logout-button" onClick={onLogout}>
              <i className="fas fa-sign-out-alt"></i> Logout
            </button>
            <div className="header-notifications">
              <NotificationSystem 
                tasks={tasks}
                drivers={drivers}
                onTaskClick={onTaskClick}
                onDriverClick={onDriverClick}
              />
            </div>
            <button
            className="fullscreen-button"
            onClick={toggleFullscreen}
            aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
            title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
          >
            <i className={`fas ${isFullscreen ? "fa-compress" : "fa-expand"}`}></i>
          </button>
      </nav>
      {showMenu && (
        <div className="navbar-overlay" onClick={closeMenu}>
          <nav className="navbar mobile-nav" onClick={(e) => e.stopPropagation()}>
            <Dropdown onToggle={(isOpen) => setShowMenu(isOpen || showMenu)}>
              <Dropdown.Toggle variant="warning" id="dropdown-basic">
                Choisir ville
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => focusVille(33.5745214, -7.6119033)}>
                  CASABLANCA
                </Dropdown.Item>
                <Dropdown.Item onClick={() => focusVille(33.5215301, -7.8280355)}>
                  DAR BOUZZA
                </Dropdown.Item>
                <Dropdown.Item onClick={() => focusVille(31.6294723, -7.9810845)}>
                  MARRAKECH
                </Dropdown.Item>
                <Dropdown.Item onClick={() => focusVille(34.020882, -6.84165)}>
                  RABAT
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <a
              href="/planning"
              target="_blank"
              className="nav-link"
              onClick={closeMenu}
            >
              Planning
            </a>
                <button 
                  className="dashboard-toggle-btn" 
                  onClick={() => {
                    onDashboardToggle();
                    closeMenu();
                  }}
                  title="Dispatch Overview"
                >
                  <i className="fas fa-chart-bar"></i>
                  <span>Overview</span>
                </button>
                <a
                  href="https://channelmanager.ma/Support"
                  target="_blank"
                  className="nav-link"
                  onClick={closeMenu}
                >
                  Delivrini - Support
                </a>
                <button className="logout-button" onClick={handleLogoutClick}>
                  <i className="fas fa-sign-out-alt"></i> Logout
                </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;